import { render, staticRenderFns } from "./DriversNew.vue?vue&type=template&id=dac0adb6&"
import script from "./DriversNew.vue?vue&type=script&lang=js&"
export * from "./DriversNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports